'use client'
import dynamic from 'next/dynamic'
import {GlobalSettings} from "@/configuration/global-settings";

const TopSliderCarousel = dynamic(() => import("@/components/shared/top-slider-carousel"));
import {
    Card,
    CardHeader,
    Image,
    Tab,
    Tabs
} from "@nextui-org/react";
import SharedServiceInstance from "@/services/shared-service";
import NextImage from "next/image";
import {useEffect, useState} from "react";
import {IconButton} from "@material-tailwind/react";
import {FaAngleLeft, FaAngleRight} from "react-icons/fa";
import Swipe from "react-easy-swipe";
import Link from "next/link";
import LoadingCommon from "@/components/shared/loadingCommon";
import SharedService from "@/services/shared-service";

export default function TopSlider({data, banners}) {
    return (
        <div className="max-w-full">
            <Banner data={data.value}/>
            <TopSliderCarousel images={banners}/>
        </div>
    );
}

function Banner({ data }) {
    const sharedService = SharedServiceInstance;
    const [selected, setSelected] = useState(0);
    const [pointer, setPointer] = useState(false);
    const visibleData = data.length > 5 ? data.slice(0, 5) : data;

    const handleNext = () => {
        setSelected((prev) => (prev + 1) % visibleData.length);
    };

    const handlePrev = () => {
        setSelected((prev) => (prev - 1 + visibleData.length) % visibleData.length);
    };

    const getImageUrl = (item) => {
        return sharedService.isValidUrl(item.hotNewsPhoto)
            ? sharedService.getOptimizeImage(item.hotNewsPhoto, 'top-slider')
            : sharedService.getOptimizeImage(`${GlobalSettings.Settings.Server}/${item.hotNewsPhoto}`, 'top-slider');
    };

    useEffect(() => {
        if (!pointer) {
            const timer = setInterval(handleNext, 10000);
            return () => clearInterval(timer);
        }
    }, [selected, pointer]);

    return (
        <div className="flex flex-col" onMouseEnter={() => setPointer(true)} onMouseLeave={() => setPointer(false)}>

            <Card className="rounded-t-[5px] rounded-b-none h-full">
                <CardHeader className="group relative w-full p-0 aspect-auto">
                    <Swipe className="w-full h-full" onSwipeLeft={handleNext} onSwipeRight={handlePrev}>
                        <Link className="w-full" href={sharedService.getPostPath(visibleData[selected])}>
                            <NextImage
                                src={getImageUrl(visibleData[selected])}
                                alt={visibleData[selected].title}
                                fill
                                priority
                                quality={100}
                                className="!w-full !relative object-contain !h-[unset] transition-opacity duration-500"
                            />
                        </Link>
                    </Swipe>

                    <div className="hidden group-hover:block z-50">
                        <IconButton
                            variant="text"
                            color="white"
                            size="lg"
                            onClick={handlePrev}
                            className="max-w-[32px] max-h-[32px] md:max-w-[64px] md:max-h-[64px] !absolute top-1/2 left-0 -translate-y-2/4 bg-gray-600/60"
                        >
                            <FaAngleLeft className="fill-white md:text-5xl text-2xl" />
                        </IconButton>
                        <IconButton
                            variant="text"
                            color="white"
                            size="lg"
                            onClick={handleNext}
                            className="max-w-[32px] max-h-[32px] md:max-w-[64px] md:max-h-[64px] !absolute top-1/2 right-0 -translate-y-2/4 bg-gray-600/60"
                        >
                            <FaAngleRight className="fill-white md:text-5xl text-2xl" />
                        </IconButton>
                    </div>
                </CardHeader>
            </Card>


            <Tabs
                aria-label="Options"
                selectedKey={
                    selected < 5 ? selected.toString() : undefined
                }
                disableAnimation
                color="primary"
                variant="underlined"
                onSelectionChange={(key) => setSelected(parseInt(key))}
                classNames={{
                    base: "order-last",
                    tabList: "w-full relative rounded-b-[5px] p-0 md:gap-0 gap-2 justify-center bg-white",
                    tab: "max-w-fit px-0 h-full after:md:h-[5px] after:hidden after:md:block after:w-[100%] after:left-0",
                    tabContent: "whitespace-normal text-justify",
                    panel: "pt-3 pb-0 px-0"
                }}
            >
                {visibleData.map((item, index) => (
                    <Tab
                        key={index}
                        title={
                            <>
                                <div className={`sm:hidden rounded-full ${selected === index ? 'w-[16px] h-[8px] bg-primary' : 'w-[8px] h-[8px] bg-gray-600'}`} />
                                <Link href={SharedService.getPostPath(item)} className="hidden md:flex md:py-5 items-center">
                                    <div className={`flex flex-col ${selected === index ? 'text-primary' : ''} ${index > 0 ? 'border-l-2 border-black' : ''} px-5`}>
                                        <p className="md:text-medium line-clamp-1 font-bold">
                                            {item.categories.find(c => c.code === item.categoryCode)?.name.toUpperCase()}
                                        </p>
                                        <p className="text-sm md:text-medium font-bold line-clamp-2">{item.title}</p>
                                        <p className="md:text-medium line-clamp-1 md:line-clamp-2 text-[0.725rem] md:pt-2 pt-1">{item.metaDescription}</p>
                                    </div>
                                </Link>
                            </>
                        }
                    />
                ))}
            </Tabs>
        </div>
    );
}
